/**
 * Comparing string or number array content to see if there is any change in its content or order
 */
export const hasArrayContentChanged = (
  originalArray: string[] | number[],
  updatedArray: string[] | number[]
) => JSON.stringify(originalArray) !== JSON.stringify(updatedArray)
